<template>
	<div class="sf-account login h-100">
		<router-view></router-view>
	</div>
</template>
<script>
//로그인, 비밀번호 변경, 비밀번호 초기화 페이지 화면의 baseLayout
//로그인 페이지 배경, copyright 등의 레이아웃을 공유 함
export default {};
</script>
<style></style>
